export default {
    titles: {
        users: 'Usuários',
        taxes: 'Taxas',
        resellers: 'Parceiros',
        'bill-items': 'Itens de Faturas',
        'commission-items': 'Itens de Comissões',
        customers: 'Clientes',
        leads: 'Leads',
        bills: 'Faturas',
        colors: 'Cores',
        contents: 'Conteúdos',
        emails: 'Emails',
        modules: 'Módulos',
        reseller: 'Parceiro',
        roles: 'Perfis de Usuários',
        commissions: 'Comissão',
        tags: 'Tags',
        medias: 'Mídias',
        'bank-account': 'Contas Bancárias',
        periods: 'Períodos',
        'commission-activations': 'Comissão por Ativações',
        'commission-categories': 'Categorias de Comissão',
        'commission-configurations': 'Configurações de Comissão',
        'commission-rules': 'Regras de Comissão',
        plans: 'Planos',
        'action-logs': 'Logs de Atividades',
        'config-plans': 'Configurações de Planos',
        'mail-settings': 'Configurações de E-mails',
        address: 'Endereços',
        products: 'Produtos',
        'product-sales': 'Vendas de Produtos',
        report: 'Relatórios',
        'landing-pages': 'Páginas de Captação',
        'popup-settings': 'Popups',
        notifications: 'Notificações',
        'plan-packages': 'Pacotes de Planos',
        'plan-proposals': 'Propostas de Plano',
        'plan-package-modules': 'Módulos de Pacotes de Planos',
        settings: 'Configurações',
        'erp-webhooks': 'Erp Webhooks',
    },

    names: {
        index: 'Listar',
        store: 'Adicionar',
        update: 'Atualizar',
        show: 'Exibir',
        delete: 'Remover',
        restore: 'Restaurar',
        'create-customer': 'Gerar cliente',
        'master-update': '[Master] Atualizar',
        'master-restore': '[Master] Restaurar',
        'master-store': '[Master] Criar',
        bill: 'Faturas',
        booking: 'Bookings',
        reseller: 'Parceiros',
    },
}
